module.exports = __webpack_public_path__ + "img/SC.9efa1029.svg";